export const SET_DANH_SACH_PHIM = 'SET_DANH_SACH_PHIM';
export const SET_FILM_DANG_CHIEU = 'SET_FILM_DANG_CHIEU';
export const SET_FILM_SAP_CHIEU = 'SET_FILM_SAP_CHIEU';
export const SET_THONG_TIN_PHIM = 'SET_THONG_TIN_PHIM';

                                                                        